{{#if @shared.isServer}}
	<script type="text/plain" id="ractive-data">
		<<RACTIVE_SERIALIZED_DATA>>
	</script>
	<script type="text/plain" id="ractive-shared">
		{{@shared.escape(JSON.stringify({ serverHost: @shared.serverHost, assetsHost: @shared.assetsHost, apiDocsHost: @shared.apiDocsHost, assetsVersion: @shared.assetsVersion, logoDevPublicToken: @shared.logoDevPublicToken, route: @shared.route, params: @shared.params, qsParams: @shared.qsParams, options: @shared.options }))}}
	</script>
{{/if}}
